export function OutlineAaeeSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1557 11.1723L14.6446 14.6612H4.916C3.85113 14.6612 2.98242 13.7878 2.98242 12.7229V6.91286C2.98242 5.84799 3.85113 4.97461 4.916 4.97461H4.95803L9.47905 9.49563L11.1557 11.1723Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3103 14.5078C20.0015 14.2135 20.4919 13.5223 20.4919 12.7237V6.9136C20.4919 5.84873 19.6232 4.97536 18.5583 4.97536H18.4322C18.208 3.87312 17.2319 3.03711 16.0596 3.03711C14.8873 3.03711 13.9065 3.87312 13.6823 4.97536H9.77783"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.26001 20.4727H15.177"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6975 14.6621V20.4722"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6975 14.6609V12.7227"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.85425 14.6609V12.7227"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.98242 3L4.95803 4.97561L9.47905 9.49663L11.1557 11.1733L14.6446 14.6622L14.6539 14.6715L16.6062 16.6238L19.9222 19.9398V19.9445L20.9824 21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
